export default "__VITE_ASSET__DfqxX6mE__"